export default {
      id: "oc-res-table-storage-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-table-storage",
      toString: function () {
        return this.url;
      }
    }